define('OutSystems/ClientRuntime/modules/Common/BrowserUtils',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isSafari = exports.windowInsideIframe = void 0;
    function windowInsideIframe(win) {
        try {
            return win && win.self !== win.top;
        }
        catch (e) {
            return true;
        }
    }
    exports.windowInsideIframe = windowInsideIframe;
    function isSafari(userAgent) {
        return /^((?!chrome|android).)*safari/i.test(userAgent);
    }
    exports.isSafari = isSafari;
});
//# sourceMappingURL=BrowserUtils.js.map;
